"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMoo = isMoo;
exports.toLink = toLink;
exports.toLogin = toLogin;
exports.toActCenter = toActCenter;
const webapi_1 = require("@fegobull/webapi");
// 定义URL映射对象的类型
const { useBehaviour } = webapi_1.use;
const { runBehaviour } = useBehaviour();
function isMoo() {
    return location.host.includes('moomoo');
}
/**
 * 跳转到活动详情
 *
 * @param {string} url 活动详情链接
 */
function toLink(url, options) {
    runBehaviour(null, Object.assign({ value: url, type: 'link', withQuery: true }, options));
}
/**
 * 跳转到登录
 */
function toLogin() {
    runBehaviour(null, {
        type: 'login',
        loginType: 'login',
        withQuery: true
    }, null, 'jumpLogin');
}
function toActCenter() {
    toLink(isMoo() ? 'https://promo.moomoo.com/welfare-center/v2' : 'https://promo.futunn.com/welfare-center/v2');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGluay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImxpbmsudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFPQSxzQkFFQztBQU1ELHdCQVNDO0FBS0QsMEJBV0M7QUFFRCxrQ0FFQztBQTVDRCw2Q0FBdUM7QUFFdkMsZUFBZTtBQUVmLE1BQU0sRUFBRSxZQUFZLEVBQUUsR0FBRyxZQUFHLENBQUM7QUFDN0IsTUFBTSxFQUFFLFlBQVksRUFBRSxHQUFHLFlBQVksRUFBRSxDQUFDO0FBRXhDLFNBQWdCLEtBQUs7SUFDakIsT0FBTyxRQUFRLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUM1QyxDQUFDO0FBQ0Q7Ozs7R0FJRztBQUNILFNBQWdCLE1BQU0sQ0FBQyxHQUFXLEVBQUUsT0FFbkM7SUFDRyxZQUFZLENBQUMsSUFBSSxrQkFDYixLQUFLLEVBQUUsR0FBRyxFQUNWLElBQUksRUFBRSxNQUFNLEVBQ1osU0FBUyxFQUFFLElBQUksSUFDWixPQUFPLEVBQ1osQ0FBQztBQUNQLENBQUM7QUFFRDs7R0FFRztBQUNILFNBQWdCLE9BQU87SUFDbkIsWUFBWSxDQUNSLElBQUksRUFDSjtRQUNJLElBQUksRUFBRSxPQUFPO1FBQ2IsU0FBUyxFQUFFLE9BQU87UUFDbEIsU0FBUyxFQUFFLElBQUk7S0FDbEIsRUFDRCxJQUFJLEVBQ0osV0FBVyxDQUNkLENBQUM7QUFDTixDQUFDO0FBRUQsU0FBZ0IsV0FBVztJQUN2QixNQUFNLENBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQyxDQUFDLDRDQUE0QyxDQUFDLENBQUMsQ0FBQyw0Q0FBNEMsQ0FBQyxDQUFDO0FBQ2xILENBQUMifQ==